import { Component, OnInit } from '@angular/core';
import {LoginResponse} from "../../../authentication/models/login-response.dto";
import {AdminsDashboardService} from "../../service/admins-dashboard.service";


interface CalendarDay {
  date: Date;
  isCurrentMonth: boolean;
}

@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss']
})
export class CalendarComponent implements OnInit {

  currentMonth: Date = new Date();
  weeks: CalendarDay[][] = [];
  weekDays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

  holidays: { date: string; label: string }[]= [];

  ngOnInit(): void {

    let currentUserInfo: LoginResponse = JSON.parse(localStorage.getItem('currentUserInfo') ?? '{}');

    if (currentUserInfo?.id != null) {
      this.getAssessmentDates(currentUserInfo?.id);
    };

    this.generateCalendar();
  }

  constructor(private  adminsDashboardService: AdminsDashboardService,) {
  }

  generateCalendar(): void {
    const year = this.currentMonth.getFullYear();
    const month = this.currentMonth.getMonth();

    const firstDayOfMonth = new Date(year, month, 1);
    const lastDayOfMonth = new Date(year, month + 1, 0);
    const startDate = new Date(firstDayOfMonth);
    startDate.setDate(1 - startDate.getDay());

    const endDate = new Date(lastDayOfMonth);
    endDate.setDate(endDate.getDate() + (6 - endDate.getDay()));

    const tempWeeks: CalendarDay[][] = [];
    let currentDate = new Date(startDate);

    while (currentDate <= endDate) {
      const week: CalendarDay[] = [];
      for (let i = 0; i < 7; i++) {
        week.push({
          date: new Date(currentDate),
          isCurrentMonth: currentDate.getMonth() === month
        });
        currentDate.setDate(currentDate.getDate() + 1);
      }
      tempWeeks.push(week);
    }

    this.weeks = tempWeeks;
  }

  isToday(date: Date): boolean {
    const today = new Date();
    return date.getDate() === today.getDate()
      && date.getMonth() === today.getMonth()
      && date.getFullYear() === today.getFullYear();
  }

  isHoliday(date: Date): boolean {
    return this.holidays.some(
      h => new Date(h.date).toDateString() === date.toDateString()
    );
  }

  getHolidayLabel(date: Date): string | null {
    const holiday = this.holidays.find(
      h => new Date(h.date).toDateString() === date.toDateString()
    );
    return holiday?.label || null;
  }

  prevMonth(): void {
    this.currentMonth = new Date(this.currentMonth.getFullYear(), this.currentMonth.getMonth() - 1);
    this.generateCalendar();
  }

  nextMonth(): void {
    this.currentMonth = new Date(this.currentMonth.getFullYear(), this.currentMonth.getMonth() + 1);
    this.generateCalendar();
  }

  private getAssessmentDates(id: number | undefined) {
    this.adminsDashboardService.getAssessmentDates(id).subscribe({
      next: (res: any) => {

        this.holidays= res.data;

      }
    });
  }

}
